import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: "I've never left a barbershop this happy. The Axel team truly listens to what you want.",
  author: 'Maria G.',
  initial: 'M'
}, {
  quote: 'The best fade of my life, no exaggeration. Everyone asks me where I got my hair cut.',
  author: 'Carlos M.',
  initial: 'C'
}, {
  quote: 'Finally a place where they understand what I want. The vibe is incredible and the result is perfect.',
  author: 'Alex R.',
  initial: 'A'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-matte relative" data-id="element-120">
      <div className="absolute left-0 top-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/5 via-transparent to-transparent pointer-events-none" data-id="element-121"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-123">
          <h2 className="font-display text-3xl md:text-5xl text-gold mb-4 italic" data-id="element-124">
            What Our Clients Say
          </h2>
          <div className="flex justify-center gap-1 mt-4" data-id="element-125">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-126" />)}
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-127">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-dark p-8 rounded-lg border border-white/5 relative" data-id="element-128">
              <span className="absolute top-4 left-6 font-display text-6xl text-gold/20 leading-none" data-id="element-129">
                "
              </span>

              <div className="flex gap-1 mb-6 relative z-10" data-id="element-130">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-131" />)}
              </div>

              <p className="font-body text-cream italic font-light leading-relaxed mb-8 relative z-10 min-h-[80px]" data-id="element-132">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-133">
                <div className="w-10 h-10 rounded-full bg-gold/20 border border-gold/50 flex items-center justify-center" data-id="element-134">
                  <span className="font-display text-gold font-bold" data-id="element-135">
                    {testimonial.initial}
                  </span>
                </div>
                <span className="font-body text-white font-medium" data-id="element-136">
                  {testimonial.author}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}